// extracted by css-extract-rspack-plugin
export default {"commaSpan":"am8DHBIOfeIB9Efs","orText":"aUXlDnwmUQ4B8exl"};